<template>
  <section class="slide08--wwrap">
    <div class="container slide08">
      <h2 class="slide08--tit">We are all Lifening.</h2>
      <div class="swiper-container slide0802">
        <div class="swiper-wrapper slide08--wrapper">
          <div class="swiper-slide slide08--txt">
            <div class="slide08--wrap">
              <p class="slide08--p tit">
                살아가고 있습니다. 누구와 함께?
              </p>
              <p class="slide08--p">
                언제나 어디서나 수많은 존재들과 어울려 살아가야 하는 세상. <br>
                혼자라고 느끼는 모든 순간에도 누군가는 나와 함께 합니다. 
              </p>
              <p class="slide08--p">
                가끔은 외로움과 슬픔에 빠지기도 하지만, 잊지 않았으면.
              </p>
              <p class="slide08--p">
                우리는 늘 누군가와 함께입니다. <br>
                수많은 생명과 공존하는 세상, <br>
                불쑥불쑥 외롭지만 오늘도 한껏 즐겨보려 합니다.
              </p>
            </div>
          </div>
          <div class="swiper-slide slide08--txt">
            <div class="slide08--wrap">
              <p class="slide08--p tit">
                살아가고 있습니다. 무엇을 위해?
              </p>
              <p class="slide08--p">
                삶의 기준은, 마음속에 품은 나만의 꿈. <br>
                지친 우리를 다시 일으켜 세우는 것은 언제나 꿈입니다.
              </p>
              <p class="slide08--p">
                때론 구름에 가려 막막할 때도 있지만, 잊지 않았으면.
              </p>
              <p class="slide08--p">
                꿈을 꾸는 그 자체로 몸과 마음은 새로워집니다. <br>
                꿈의 거리를 좁힐 수 있는 나만의 에너지를 축적하고, <br>
                오늘도 더욱 힘을 내봅니다.
              </p>
            </div>
          </div>
          <div class="swiper-slide slide08--txt pc">
            <div class="slide08--wrap">
              <p class="slide08--p tit">
                살아가고 있습니다. 어디를 향해?
              </p>
              <p class="slide08--p">
                삶은, 닿을 수 없는 목적지를 향한 끝없는 여정. <br>
                우리는 누군가의 여정을 함께 하는 빛이자 동반자입니다.
              </p>
              <p class="slide08--p">
                가끔은 잘못된 길을 걷다 되돌아오기도 하지만, 잊지 않았으면.
              </p>
              <p class="slide08--p">
                우리는 목표와 한 걸음 더 가까워졌습니다. <br>
                가끔은 후회해도 걷는 길 자체를 즐길 수 있도록, <br>
                오늘도 한걸음 내디뎌 봅니다.
              </p>
            </div>
          </div>
          <div class="swiper-slide slide08--txt">
            <div class="slide08--wrap">
              <p class="slide08--p tit">
                살아가고 있습니다. 언제나 지금.
              </p>
              <p class="slide08--p">
                작은 일에 쉽게 흔들지 않는 비결은 단단한 나의 중심. <br>
                복잡한 모임에서도 편안한 모습으로 주변과 어울리고, 
              </p>
              <p class="slide08--p">
                길고양이를 돌보며 작은 꽃밭을 가꾸는 사람, 잊지 않았으면.
              </p>
              <p class="slide08--p">
                진정한 빛은 그런 사람의 마음에서 나옵니다. <br>
                스스로를 아끼고 꾸준히 가꾼다면, <br>
                우리 모두는 언제까지나 빛날 수 있습니다.
              </p>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

  </section>
</template>

<script>
import Swiper from '@/assets/plugins/swiper.min';
import '@/assets/plugins/swiper.min.css';

export default {
  name: 'Section8',
  data(){
    return{
      slide08: Swiper,
    }
  },
  mounted() {
    this.slide08 = new Swiper('.slide0802', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      speed: 500,
      slidesPerView: 4,
      // height: 600,
      effect: 'slide',
      // loop: true,
      // autoplay: {
        //   delay: 3000,
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: '.swiper-pagination',
        // type: 'bullets',
      },
      breakpoints: {
        600: {
          slidesPerView: 1,
          // pagination: false,
          // navigation: false,
          height: '100vh',
          // scrollbar: {
          //   el: '.slide1 .btn_controllLR .swiper-scrollbar',
          //   hide: false,
          //   dragSize: 'auto',
          // },
        },
      },
    });
  },
};
</script>